
export enum buttonTypes {
  confirmBtn = 'confirm',
  cancelBtn = 'cancel',
  optionBtn = 'option',
  primaryGreen = 'primary-green',
  primaryRed = 'primary-red',
  actionPrimary = 'action-primary',
  actionPrimarySmall = 'action-primary-small',
  secondary = 'secondary',
  actionSecondary = 'action-secondary',
  actionSecondarySmall = 'action-secondary-small',
}
export enum ShapeTypeEnum {
  Rectangle = 'rect',
  Circle = 'circle',
  Text = 'text',
  Area = 'area',
  Wall = 'wall',
  Ellipse = 'ellipse',
  BasicRectangle = "brect",
  BasicCircle = 'bcircle',
  Pin = 'pin',
  Image = 'image'
}
export const fieldType: string[] = ['Text Field', 'Drop Down'];

// export interface InputImages {
//   ImageId: string;
//   bytes: string;
//   isImageSelected?: boolean;
// }

export const guestDetails = ['primaryGuest', 'secondaryGuest1', 'secondaryGuest2', 'secondaryGuest3'];

export enum componentName {
  reservationDetails = 0,
  tablesLayout = 1,
  guestDetails = 2,
  confirmDetails = 3,
  terms_of_use = 4,
  privacy_policy = 5,
  data_rentention_policy = 6,
}

export enum ComponentTypes {
  cancelReservation,
  dataRetentionPolicy,
  financialEffectCalculation,
  informationPopup,
  deleteSecondaryGuest,
  seatingTypeInfoPopup,
  AuthRefundPopup,
  cancellationChargeInfo,
  clearCart,
  cartLockWarningMessage,
  InfoPopup, 
  GuestDetails
}

export enum BookingBehavior {
  OpenBooking,
  ClassOrSession,
  PrivateLesson
}

export enum PartyState {
  Pending,
  Seated,
  Left,
  NoShowed,
  Cancelled,
  Confirmed,
  CheckedIn,
  CheckedOut,
  Open, // not available in API
  Blocked // not available in API
}

export enum AvailabilityCriteria {
  None = 0,
  IncludeLocation = 1,
  IncludeInstructor = 2,
  IncludeLocationAndInstructor = 3,
}

export enum Labels {
  slotTimeAM = 66,
  slotTimePM = 67,
}

export enum activityStatus {
  All = 0,
  InProgress = 1,
  Future = 2
}

export enum ActivityViewType {
List,
Grid,
Both
}

export enum ActivityTabs {
  BookingSelection,
  ActvityView,
  ActivitySelection,
  PrivateLesson,
  ReservationDetails,
  CartDetails,
  ConfirmationSummary,
  AdditionalGuest
}
export enum GuestTitle {
  None = 0,
  "Mr" = 1,
  "Mrs",
  "Ms",
  "His Excellency Ambassador",
  "Your Excellency",
  "Dame",
  "Dato",
  "Dr",
  "Dr & Mr",
  "Dr & Mrs",
  "Governor",
  "His/Her honourable",
  "Lady",
  "Lord",
  "Madame",
  "Mayor",
  "Monsieur",
  "Mr & Mr",
  "Mr & Mrs",
  "Her Royal Highness",
  "His Royal Highness",
  "Professor",
  "Sir",
  "Miss",
  "Fr",
  "Prof",
  "Rev",
  "Congrm",
  "Congrw",
  "Sen",
  "Amb",
  "Sr",
  "Admin",
  "Mr/S",
  "Judge"
}

export enum ManualSlotType {
  FromDefaultSlot,
  BrandNewSlot,
  EditedFromDefaultSlot
}


export enum SlotType {
  Time,
  ActualSlot,
  DefaultSlot
}

export enum AutomaticRefundState {
  NotApplicable,
  Succeeeded,
  Failed
}



export enum PropertyType {
  Restaurant = "Restaurant",
  Auditorium = "Auditorium",
  Cabana = "Cabana",
  MovieTheatre = "MovieTheatre",
  TennisCenter = "TennisCenter",
  General = "General"
}

export enum PropertyTypeId {
  Restaurant = 1,
  Auditorium = 2,
  Cabana = 3,
  MovieTheatre = 4,
  TennisCenter = 5,
  General = 6
}

export enum AuthorizePaymentType {
  Authorize_Only = 1, //(Authorize from CC)
  Payment_Only = 2, //(Charge/Sale from CC)
  Post_To_RoomCharge = 3,
  Recurring_Payment = 4, //(Schedule)
  Loyalty_Point = 5,
  AuthStripe = 6, //(Gpay/Apple pay)
  Authorize_Document = 7, //(Waiver)
  Capture_Payment = 8,
  CreditCardToken = 13,
  GiftCard = 16
}

export enum PartyNoteTypes {
  FreeFormNote = 0,
  PredefinedNote = 1,
  SpecialRequest = 2,
  PromoCode = 3,
  SpecialMeal = 4,
}

export enum NoteType {
  partyNote,
  guestNote

}

export enum HeaderStyle {
  none = 'None',
  custom = 'Custom',
  agilysys = "Agilysys",
  cityEats = "CityEats"
}

export enum Status {
  New = 0,
  Approved = 10,
  Inactive = 90,
  SoftDelete = 95,
  MarkedForPurge = 99,
  Cancelled = 11
}

export enum AttributeType {
  PublicHeadlines = 1,
  PrivateHeadlines = 2
}

export const AnyVenue = [
  PropertyType.Restaurant,
  PropertyType.Auditorium,
  PropertyType.Cabana,
  PropertyType.MovieTheatre
]

export enum ScreenType {
  ReservationSetting =1,
  ReservationMessaging,
  MerchantSetting


}

export const ActivitiesVenue = [
  PropertyType.TennisCenter
]

export const propertyWithDefaultCourtArea = [
  PropertyType.TennisCenter
]

export enum LocationViewTypes {
  None = 0,
  LayoutView = 1,
  ListView = 2
}

export enum LocationFilter {
  ByArea = 1,
  ByType = 2
}

export enum ActivityBookings {
  GroupLessonBooking = 0,
  PrivateLessonBooking = 1,
  OpenBooking = 2
}

export enum BookingGuestType {
  None = 0,
  HotelGuest = 1,
  Member = 2,
  Loyalty = 3, 
  Others = 4
}

export enum ActionControl {
  None = 0,
  CanModify = 1,
  CanCancel = 2,
  CanModifyAndCancel = 3
}
    

export const ControlSettings =  {
  OpenBookingProperties: [
    PropertyType.TennisCenter,
    PropertyType.General
  ],
  DiningProperties: [
    PropertyType.Restaurant,
    PropertyType.Auditorium,
    PropertyType.Cabana,
    PropertyType.MovieTheatre
  ],
  VenueBasedActivitiesProperties: [
    PropertyType.Restaurant,
    PropertyType.Auditorium,
    PropertyType.Cabana,
    PropertyType.MovieTheatre
  ]
}

export enum DefaultReservationView {
  SpecialMeal,
  TableReservation
}

export enum PaymentItemType {
  Tax,
  ServiceCharge,
  Negotiation,
  MinRateCoverTypeAdjustment,
  BasePrice,
  Location,
  Staff,
  CoverType,
  BookingType,
  Addon,
  SpecialMeal,
  SpecialMealCovers,
  MembershipDiscount,
  AdditionalRate,
  CancellationFee,
  NoShowFee,
  MembershipRound,
  PackageDiscount,
  PromoCodeDiscount,
  Deposit,
  AddonAdditionalFee,
  AddonAdditionalFeeNonTrackable,
  AddonDeposit,
  RefundableDeposit,
  NonRefundableDeposit
}




export const chineseLanguageCodes = ['zh-s','zh-t'];
export const DEFAULT_LANGUAGE_CODE = 'en';
export const DEFAULT_LANGUAGE_ID = 1;